import React from 'react';
import solarwindsLogo from '../../assets/solarwinds-logo-white.svg';
import { CenterLayout } from '../index';
import styles from './UnifiedLayout.module.scss';
import { Image, Header, Card } from '@solarwindscloud/nighthawk-ui';
import PropTypes from 'prop-types';

export const UnifiedLayout = ({ children, headerText, dataTestId, dataTestPageName }) => (
  <Card className={styles.fullScreen} data-test-id={dataTestId} data-test-page-name={dataTestPageName}>
    <CenterLayout>
      <Image centered alt="Logo" src={solarwindsLogo} className={styles.logo} data-test-product-logo />
      {headerText && (
        <>
          <Header as="h1" className={styles.headerText} textAlign="center">
            {headerText}
          </Header>
        </>
      )}
      {children}
    </CenterLayout>
  </Card>
);

UnifiedLayout.displayName = 'UnifiedLayout';
UnifiedLayout.propTypes = {
  headerText: PropTypes.string,
  dataTestId: PropTypes.string,
  dataTestPageName: PropTypes.string,
};
